import { __awaiter, __assign, __generator } from '../../node_modules/tslib/tslib.es6.js';
import BrandclubSideWidget from '../components/BrandclubSideWidget/index.js';
import '../../analytics/events.js';
import 'uuid';
import 'lodash/includes';
import '../../types/filters.js';
import { getEntityImage } from '../../utils/assetUtils.js';
import '../../utils/brandclubStoreConfigUtils.js';
import 'numeral';
import { escapeUriPath } from '../../utils/stringUtils.js';
import '../../utils/broadcast.js';
import { PLACEHOLDER_GREEN_IMAGE, WIDGET_PAIR_PRODUCT_PADDING } from '../../utils/constants/Constants.js';
import 'awesome-phonenumber';
import React, { useState, useEffect } from 'react';
import 'lodash/isEqual';
import 'lodash/get';
import 'lodash/orderBy';
import '../../types/Campaign.js';
import '../../types/product.js';
import '../../api/graphQl/brand.js';
import '../../api/graphQl/product.js';
import { getEntityForLandingPage } from '../../api/utils.js';
import '@brandclub/types';

var placeholderImageUrl = PLACEHOLDER_GREEN_IMAGE['1X1'];
var SideBySideProducts = function (_a) {
    var _b;
    var _c = _a.leftProduct, leftProduct = _c === void 0 ? '' : _c, _d = _a.rightProduct, rightProduct = _d === void 0 ? '' : _d, LinkComponent = _a.LinkComponent, persistentQueryParams = _a.persistentQueryParams, page = _a.page, axiosEdgeCached = _a.axiosEdgeCached;
    var defaultProductValue = 'Add product';
    var hasLeftProduct = leftProduct && leftProduct !== defaultProductValue;
    var hasRightProduct = rightProduct && rightProduct !== defaultProductValue;
    var _e = useState('title'), rightProductTitle = _e[0], setRightProductTitle = _e[1];
    useEffect(function () {
        if (rightProduct && rightProduct !== defaultProductValue) {
            (function () { return __awaiter(void 0, void 0, void 0, function () {
                var data, e_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, getEntityForLandingPage({
                                    axiosEdgeCached: axiosEdgeCached,
                                    entityType: 'product',
                                    entityId: rightProduct,
                                })];
                        case 1:
                            data = (_a.sent()).data;
                            setRightProductTitle(data.title);
                            return [3 /*break*/, 3];
                        case 2:
                            e_1 = _a.sent();
                            console.error(e_1);
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            }); })();
        }
    }, [rightProduct]);
    var _f = useState('title'), leftProductTitle = _f[0], setLeftProductTitle = _f[1];
    useEffect(function () {
        if (leftProduct && leftProduct !== defaultProductValue) {
            (function () { return __awaiter(void 0, void 0, void 0, function () {
                var data, e_2;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, getEntityForLandingPage({
                                    axiosEdgeCached: axiosEdgeCached,
                                    entityType: 'product',
                                    entityId: leftProduct,
                                })];
                        case 1:
                            data = (_a.sent()).data;
                            setLeftProductTitle(data.title);
                            return [3 /*break*/, 3];
                        case 2:
                            e_2 = _a.sent();
                            console.error(e_2);
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            }); })();
        }
    }, [leftProduct]);
    var leftProductProps = {
        imageUrl: hasLeftProduct ? getEntityImage(leftProduct, 'product') : placeholderImageUrl,
        imageLink: {
            id: hasLeftProduct
                ? "/".concat(escapeUriPath(leftProductTitle.substring(0, 40)), "/p/").concat(leftProduct, "/product?").concat(persistentQueryParams || '')
                : "?".concat(persistentQueryParams || '', "#"),
            displayName: '',
        },
    };
    var rightProductProps = {
        imageUrl: hasRightProduct ? getEntityImage(rightProduct, 'product') : placeholderImageUrl,
        imageLink: {
            id: hasRightProduct
                ? "/".concat(escapeUriPath(rightProductTitle.substring(0, 40)), "/p/").concat(rightProduct, "/product?").concat(persistentQueryParams || '')
                : "?".concat(persistentQueryParams || '', "#"),
            displayName: '',
        },
    };
    var fullWidth = !!((_b = page === null || page === void 0 ? void 0 : page.containerConfigOverride) === null || _b === void 0 ? void 0 : _b.width);
    return (React.createElement(BrandclubSideWidget, { fullWidth: fullWidth, leftSideProps: __assign(__assign({ type: 'image' }, leftProductProps), { imageStyle: {
                boxSizing: 'border-box',
                padding: hasLeftProduct ? WIDGET_PAIR_PRODUCT_PADDING : 0,
            } }), rightSideProps: __assign(__assign({ type: 'image' }, rightProductProps), { imageStyle: {
                boxSizing: 'border-box',
                padding: hasRightProduct ? WIDGET_PAIR_PRODUCT_PADDING : 0,
            } }), LinkComponent: LinkComponent }));
};

export { SideBySideProducts };
//# sourceMappingURL=index.js.map
